import {Component, OnDestroy, OnInit} from '@angular/core';
import {UserTagModel} from "../../models/user-tag.model";
import {Http} from "@angular/http";
import {SpotifyTagsService} from "../../services/spotify-tags-service";
import {Router} from "@angular/router";
import {FolderModel} from "../../models/folder.model";
import {FolderTagModel} from "../../models/folder-tag.model";
import {FoldersAndTagsModel} from "../../models/folders-and-tags.model";
import {ExpandedFoldersService} from "../../services/expanded-folders-service";
import {AddTagModel} from "../../models/add-tag.model";
import {AddFolderModel} from "../../models/add-folder.model";
import {EditTagModel} from "../../models/edit-tag.model";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-tags',
  styleUrls: ['./tags.component.css'],
  templateUrl: './tags.component.html'
})
export class TagsComponent implements OnInit, OnDestroy {
  tags: UserTagModel[];
  artistTags: UserTagModel[];
  albumTags: UserTagModel[];
  folders: FolderModel[];
  artistFolders: FolderModel[];
  albumFolders: FolderModel[];
  showAddTag = false;
  showEditTag = false;
  showDeleteTag = false;
  showAddFolder = false;
  showEditFolder = false;
  addErrorMessage: string;
  editErrorMessage: string;
  selectedTagToEdit: UserTagModel;
  selectedTagToDelete: UserTagModel;
  selectedFolderToEdit: FolderModel;
  showDeleteFolder = false;
  selectedFolderToDelete: FolderModel;
  private readonly ARTIST = 'ARTIST';
  private readonly ALBUM = 'ALBUM';

  tagToEditSubscription: Subscription;
  tagToDeleteSubscription: Subscription;
  folderToEditSubscription: Subscription;
  folderToDeleteSubscription: Subscription;

  constructor(private http: Http, private spotifyTagsService: SpotifyTagsService, public expandedFoldersService: ExpandedFoldersService, private router: Router) {}

  ngOnInit() {
    console.log("In ngOnInit in tags component")
    this.spotifyTagsService.getTags().subscribe(response => {
      this.initializeTagsAndFolders(response);
    });
    this.tagToEditSubscription = this.spotifyTagsService.tagToEdit$.subscribe(tagToEdit => {
      this.toggleShowEditTag(tagToEdit);
    });
    this.tagToDeleteSubscription = this.spotifyTagsService.tagToDelete$.subscribe(tagToDelete => {
      this.toggleShowDeleteTag(tagToDelete);
    });
    this.folderToEditSubscription = this.spotifyTagsService.folderToEdit$.subscribe(folderToEdit => {
      this.toggleShowEditFolder(folderToEdit);
    });
    this.folderToDeleteSubscription = this.spotifyTagsService.folderToDelete$.subscribe(folderId => {
      this.toggleShowDeleteFolder(folderId);
    });
  }

  ngOnDestroy(): void {
    this.tagToEditSubscription.unsubscribe();
    this.tagToDeleteSubscription.unsubscribe();
    this.folderToEditSubscription.unsubscribe();
    this.folderToDeleteSubscription.unsubscribe();
  }

  initializeTagsAndFolders(tagsAndFolder: FoldersAndTagsModel) {
    this.tags = tagsAndFolder.tags;
    this.artistTags = tagsAndFolder.tags.filter(tag => tag.tagType === this.ARTIST);
    this.albumTags = tagsAndFolder.tags.filter(tag => tag.tagType === this.ALBUM);
    this.folders = tagsAndFolder.folders;
    this.artistFolders = tagsAndFolder.folders.filter(folder => folder.tagType === this.ARTIST);
    this.albumFolders = tagsAndFolder.folders.filter(folder => folder.tagType === this.ALBUM);
  }

  addTag(addTag: AddTagModel) {
    this.spotifyTagsService.addTag(addTag).subscribe(response => {
      this.initializeTagsAndFolders(response);
      this.showAddTag = false;
      this.navigateToTag(response.tag);
    }, error => {
      this.addErrorMessage = error.error.message
    })
  }

  editTag(oldTag: UserTagModel, newTag: EditTagModel, ) {
    this.spotifyTagsService.editTag(oldTag, newTag).subscribe(response => {
      this.initializeTagsAndFolders(response);
      this.showEditTag = false;
      this.navigateToTag(response.tag);
      this.spotifyTagsService.tagEdited(response.tag);
    }, error => this.editErrorMessage = error.error);
  }

  deleteTag() {
    this.spotifyTagsService.deleteTag(this.selectedTagToDelete.tagId).subscribe(() => {
      this.spotifyTagsService.getTags().subscribe(response => {
        this.initializeTagsAndFolders(response);
        this.showDeleteTag = false;
        this.navigateToArtistsOrAlbums(this.selectedTagToDelete.tagType);
      })
    }, error => this.editErrorMessage = error.error)
  }

  addFolder(addFolder: AddFolderModel) {
    this.spotifyTagsService.addFolder(addFolder).subscribe(response => {
      this.initializeTagsAndFolders(response);
      this.showAddFolder = false;
      this.navigateToFolder(response.folder);
    }, error => this.addErrorMessage = error.error)
  }

  editFolder(oldFolder: FolderModel, newFolder: string) {
    this.spotifyTagsService.editFolder(oldFolder, newFolder).subscribe(response => {
      this.initializeTagsAndFolders(response);
      this.showEditFolder = false;
      this.navigateToFolder(response.folder);
      this.spotifyTagsService.folderEdited(newFolder);
    }, error => this.editErrorMessage = error.error)

  }

  deleteFolder() {
    this.spotifyTagsService.deleteFolder(this.selectedFolderToDelete.folderId).subscribe(() => {
      this.spotifyTagsService.getTags().subscribe(response => {
        this.initializeTagsAndFolders(response);
        this.showDeleteFolder = false;
        this.navigateToArtistsOrAlbums(this.selectedFolderToDelete.tagType)
      })
    })
  }

  navigateToTag(tag: UserTagModel) {
    if (tag.folderId) {
      this.expandedFoldersService.addFolderToExpand(tag.folderId);
    }
    if (tag.tagType === this.ARTIST) {
      this.expandedFoldersService.setExpandArtists(true);
      this.spotifyTagsService.navigate();
      this.router.navigateByUrl(`artists/${tag.tagId}`);
    } else {
      this.expandedFoldersService.setExpandAlbums(true);
      this.spotifyTagsService.navigate();
      this.router.navigateByUrl(`albums/${tag.tagId}`);
    }
  }

  navigateToFolder(folder: FolderModel) {
    if (folder.tagType === this.ARTIST) {
      this.expandedFoldersService.setExpandArtists(true);
      this.spotifyTagsService.navigate();
      this.router.navigateByUrl(`artists/folder/${folder.folderId}`);
    } else {
      this.expandedFoldersService.setExpandAlbums(true);
      this.spotifyTagsService.navigate();
      this.router.navigateByUrl(`albums/folder/${folder.folderId}`);
    }
  }

  navigateToArtistsOrAlbums(tagType: string) {
    if (tagType == this.ARTIST) {
      this.router.navigateByUrl('artists');
    } else {
      this.router.navigateByUrl('albums');
    }
  }

  toggleShowAddTag() {
    this.showAddTag = !this.showAddTag;
    if (!this.showAddTag) {
      this.resetAddErrorMessage();
    }
  }

  toggleShowEditTag(selectedTag?: UserTagModel) {
    this.showEditTag = !this.showEditTag;
    if (!this.showEditTag) {
      this.resetEditErrorMessage();
      this.selectedTagToEdit = null;
    } else {
      this.selectedTagToEdit = selectedTag;
    }
  }

  toggleShowDeleteTag(selectedTag?: UserTagModel) {
    this.showDeleteTag = !this.showDeleteTag;
    if (!this.showDeleteTag) {
      this.selectedTagToDelete = null;
    } else {
      this.selectedTagToDelete = selectedTag;
    }
  }

  toggleShowAddFolder() {
    this.showAddFolder = !this.showAddFolder;
    if (!this.showAddFolder) {
      this.resetAddErrorMessage();
    }
  }

  toggleShowEditFolder(selectedFolder?: FolderTagModel) {
    this.showEditFolder = !this.showEditFolder;
    if (!this.showEditFolder) {
      this.resetEditErrorMessage();
      this.selectedFolderToEdit = null;
    } else {
      this.selectedFolderToEdit = this.folders.find(folder => folder.folderId === selectedFolder.folderId);
    }
  }

  toggleShowDeleteFolder(selectedFolderId?: number) {
    this.showDeleteFolder = !this.showDeleteFolder;
    if (!this.showDeleteFolder) {
      this.selectedFolderToDelete = null;
    } else {
      this.selectedFolderToDelete = this.folders.find(folder => folder.folderId === selectedFolderId);
    }
  }

  resetAddErrorMessage() {
    this.addErrorMessage = '';
  }

  resetEditErrorMessage() {
    this.editErrorMessage = '';
  }

  isAllArtistsLinkActive(url): boolean {
    const queryParamsIndex = this.router.url.indexOf('?');
    const baseUrl = queryParamsIndex === -1 ? this.router.url :
        this.router.url.slice(0, queryParamsIndex);
    return baseUrl === url;
  }

  navigate() {
    this.spotifyTagsService.navigate();
  }
}
